import { render, staticRenderFns } from "./avg-time-sesssion.vue?vue&type=template&id=27bae33a&scoped=true&"
import script from "./avg-time-sesssion.vue?vue&type=script&lang=js&"
export * from "./avg-time-sesssion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bae33a",
  null
  
)

export default component.exports